// Updated Footer.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';
import logo from '../assets/images/CEDCoatings-Logo.png';

const Footer = () => {
  const navigate = useNavigate();

  const handleRequestQuote = () => {
    navigate('/contact');
    window.scrollTo(0, 0); // Scroll to top of Contact page
  };

  return (
    <footer className="footer-container">
      <div className="footer-header">
        <h1 className="footer-title">
          A Pioneers Commercial CED and Powder Coating Services Provider Since 2024
        </h1>
        <button onClick={handleRequestQuote} className="footer-button">Request a Quote →</button>
      </div>

      <div className="footer-content">
        {/* Logo Section */}
        <div className="footer-section">
          <img src={logo} alt="CED Coatings Logo" className="footer-logo" />
        </div>

        {/* Services Section */}
        <div className="footer-section">
          <h2 className="footer-section-title">Services</h2>
          <ul>
            <li><a href="#">CED / ED / KTL Coating Process</a></li>
            <li><a href="#">Powder Coating Process</a></li>
            <li><a href="#">Liquid Spray Painting</a></li>
          </ul>
        </div>

        {/* Products Section */}
        <div className="footer-section">
          <h2 className="footer-section-title">Products</h2>
          <ul>
            <li><a href="#">Surface Treatment Plants</a></li>
            <li><a href="#">Material Handling System</a></li>
            <li><a href="#">Plant Equipments</a></li>
          </ul>
        </div>

        {/* Legal Section */}
        <div className="footer-section">
          <h2 className="footer-section-title">Legal</h2>
          <ul>
            <li><a href="/terms">Terms of Service</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
          </ul>
        </div>

        {/* Contact Info Section */}
        <div className="footer-section">
          <h2 className="footer-section-title">Quick Contacts</h2>
          <p>If you have any questions or need help, feel free to contact our team.</p>
          <p className="footer-contact">
            <svg className="footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <path d="M22 6l-10 7L2 6" />
            </svg>
            sales@cedcoatings.in
          </p>
          <p className="footer-contact">
            <svg className="footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.9 19.9 0 01-8.63-3.72 19.36 19.36 0 01-6-6A19.9 19.9 0 012 3.77a2 2 0 012-2.05h3a2 2 0 012 1.72 12.16 12.16 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.16 12.16 0 002.81.7A2 2 0 0122 16.92z" />
            </svg>
            +91 90815 88330
          </p>

          {/* Social Icons */}
          {/* <div className="footer-social">
            <a href="https://facebook.com" aria-label="Facebook">
              <svg className="footer-social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
              </svg>
            </a>
            <a href="https://twitter.com" aria-label="Twitter">
              <svg className="footer-social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 4.557c-.883.392-1.832.656-2.828.775..." />
              </svg>
            </a>
            <a href="https://linkedin.com" aria-label="LinkedIn">
              <svg className="footer-social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M4.98 3.5c0 1.381-1.11 2.5..." />
              </svg>
            </a>
            <a href="https://instagram.com" aria-label="Instagram">
              <svg className="footer-social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012..." />
              </svg>
            </a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;